import { UseFormSetValue } from "react-hook-form"
import { DefaultValuesType } from "../VentaHabitacion.types"
import { Reserva } from "src/gql/schema"
import { useDate } from "src/shared/hooks/useDate"
import { addDays } from "src/shared/helpers/addDays"
import { useProfile } from "src/shared/hooks/useProfile"
import { DateTime } from "luxon"

const useResetForm = ({setValue}: {setValue: UseFormSetValue<DefaultValuesType>}) => {
    const {zona_horaria} = useProfile() 

    const { setHHMMSS } = useDate()
    const getDate = (date: string) => DateTime.fromISO(date, { zone: zona_horaria }).toJSDate()

    const updateResetForm = ({reserva, numero_personas = 0, isBetween12AMAndCheckOutHour, nowHotel}: {reserva: Reserva, nowHotel: Date, numero_personas?: number, isBetween12AMAndCheckOutHour: boolean}) => {
        if(reserva && Number(reserva?.reservas_tarifas?.length || 0) > 0) {
            setValue("extraUsers", reserva?.personas_extras || 0)
            setValue("name", reserva?.nombre_huesped || "")
            setValue("users", reserva?.numero_personas || 0)

            setValue("date", [getDate(reserva.fecha_entrada), getDate(reserva.fecha_salida)])
            return
        }
        setValue("extraUsers", 0)
        setValue("extraHours", 0)
        setValue("users", numero_personas)
        // si la hora está entre las 12am y la hora de checkOut se selecciona automaticamente la fecha de hoy, caso contrario se sabe que es una renta de 1 para el siguiente o más
        const today = setHHMMSS({ startDate: nowHotel, newHour: "00:00:00", isNewHourInUTC: false })

        if (isBetween12AMAndCheckOutHour) {
            return setValue("date", [today, today])
        }
        setValue("date", [today, addDays({date: today, days: 1})])
        return 
    }
    
    const resetAmount = () => {
        setValue("tarifas", [])
    }

    return {
        updateResetForm,
        resetAmount
    }
}

export default useResetForm